export default __webpack_public_path__ + "static/Retail-Webinar-blog-image-9e819668fd419c996b957d070bd2e90e.webp";